module.exports = __webpack_public_path__ + "static/media/Add_Button_Negative_Outer_Fruit.0fb38562.svg";